import React from 'react';
import { WhyJoinCardStyles as styles } from './LandingSubComponentStyles';
import Fade from 'react-reveal/Fade';
import { Event } from '../Tracking/Track';

const WhyJoinCard = props => {
  return (
    <div style={styles['parent_card_why_oyo'][props.viewMode]}>
      {!props.hideWhyOyo && (
        <Fade bottom>
          <div>
            <img
              style={styles['why_oyo_img'][props.viewMode]}
              src={props.img}
            />

            <div style={styles['why_oyo_heading'][props.viewMode]}>
              {props.heading}
            </div>
            <div style={styles['why_oyo_content'][props.viewMode]}>
              {props.content}
            </div>
            <div
              className={'hover'}
              onClick={() => {
                if (props.link)
                  props.link(
                    props.viewMode,
                    props.subContent,
                    props.heading,
                    props.img,
                    Event('Partner Page', props.eventAction, '', '')
                  );
              }}
              style={styles['why_oyo_learn_more'][props.viewMode]}
            >
              {props.learnMore}
            </div>
          </div>
        </Fade>
      )}
    </div>
  );
};

export default WhyJoinCard;
